export const getAvatarUrl = (profile: any): string | undefined => {
  try {
    const avatarIpfs = profile?.nfd?.properties?.verified?.avatar;
    if (avatarIpfs) {
      return avatarIpfs.replace('ipfs://', 'https://ipfs.io/ipfs/');
    }
    return undefined;
  } catch {
    return undefined;
  }
};
